import { render } from "./wfm-timestamp.vue?vue&type=template&id=1e2b5c35&scoped=true"
import script from "./wfm-timestamp.vue?vue&type=script&lang=js"
export * from "./wfm-timestamp.vue?vue&type=script&lang=js"

import "./wfm-timestamp.vue?vue&type=style&index=0&id=1e2b5c35&lang=css"
import "./wfm-timestamp.vue?vue&type=style&index=1&id=1e2b5c35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2b5c35"]])

export default __exports__